import './style.css';

import React from 'react';

export interface IProps {
  value?: object;
}

const Errors: React.FC<IProps> = React.memo((props) => {
  const { value } = props;

  const notifications = React.useMemo(() => {
    return Object.values(value!).map((value, i) => {
      return (
        <div className="notification error" key={i}>
          {value}
        </div>
      );
    });
  }, [value]);

  if (notifications.length === 0) {
    return null;
  }

  return <div className="editor-errors">{notifications}</div>;
});

Errors.defaultProps = {
  value: {}
};
Errors.displayName = 'Errors';

export const { defaultProps } = Errors;
export default Errors;
